module.exports = __webpack_public_path__ + "media/images/copy-36040cf2c67cb24785cc3bd54260fd1b.svg";